import clsx from 'clsx';
import { Suspense, lazy, memo } from 'react';

import { useMatchesCalendarOptions } from '../../store';

import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

const Filters = lazy(() => import(/* webpackPrefetch: true */ '../Filters'));
const CalendarService = lazy(() => import(/* webpackPrefetch: true */ '../../../calendar-service'));
const PromoAppNotification = lazy(() => import(/* webpackPrefetch: true */ '@shared/PromoAppNotification'));

const Header = ({ isSticky }: { isSticky?: boolean }) => {
  const { options } = useMatchesCalendarOptions();
  const t = useTranslateFn();

  const showCalendarService = options.enableAddToCalendar && !!options.calendarServiceApiUrl;
  const hasButtons = options.isPromoEnabled || options.filterByTeam || showCalendarService;

  if (!options.title && !hasButtons) return null;

  return (
    <header
      className={clsx(
        'pk-col',
        'pk-col--span-12',
        'pk-d--flex',
        options.title ? 'pk-justify-content--between' : 'pk-justify-content--end',
        'pk-align-items--start',
        'pk-align-items-sm--center',
        'pk-flex--column',
        'pk-flex-sm--row',
      )}
    >
      {!!options.title && (
        <h1
          className={clsx(
            'pk-text--text-01',
            'pk-font-size--xl2',
            'pk-font-size-md--xl3',
            'pk-font--comp-bold',
            hasButtons && styles.titleWithButtons,
            isSticky && styles.titleSticky,
            'pk-pb-sm--0',
          )}
        >
          {t(options.title)}
        </h1>
      )}
      {hasButtons && (
        <div className={styles.buttonsWrapper}>
          <Suspense>
            {options.isPromoEnabled && <PromoAppNotification {...options} />}
            {showCalendarService && <CalendarService options={{ ...options, calendarContext: true }} />}
            {options.filterByTeam && <Filters />}
          </Suspense>
        </div>
      )}
    </header>
  );
};

export default memo(Header);
